import { render, staticRenderFns } from "./PositionContextWatchSettingsDialog.vue?vue&type=template&id=fd2e0cd8&scoped=true&"
import script from "./PositionContextWatchSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./PositionContextWatchSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PositionContextWatchSettingsDialog.vue?vue&type=style&index=0&id=fd2e0cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2e0cd8",
  null
  
)

export default component.exports